<template>
  <v-card-text>
    <div
      v-for="(question, index) in questions"
      :key="`question - ${index}`"
    >
      <v-card class="orange darken-3 rounded-xl" dark>
      <v-card-title
        light
        class="mt-10"
      >
        {{ question.question }}
      </v-card-title>
      <v-card-text>
        <v-col
          v-for="(answer, ansindex) in question.answers"
          :key="`answer - ${ansindex}`"
          class="align"
        >
          <v-checkbox
            v-model="answerSelected[question.id]"
            :value="answer.answer"
            :label="answer.answer"
            hide-details
            dark
            color="white"
            class="shrink mr-3 mt-0"
          />
        </v-col>
      </v-card-text>
      </v-card>
    </div>
    <v-card-actions>
      <v-btn color="orange darken-3" x-large block dark
        class="rounded-xl mt-8"
        @click.prevent="onFormSubmit()"
        >
          Next
      </v-btn>
    </v-card-actions>
  </v-card-text>
</template>
<script>
export default {
  name: 'Questions',
  data: () => ({
    valid: false,
    questions: [],
    answerSelected: {},
    errorResponse: ''
  }),

  computed: {
    getCurrentSelectedUserType () {
      return this.$store.getters['decision/getCustomerType']
    }
  },

  created () {
    this.questions = this.$store.getters['questions/getQuestions']
  },

  methods: {
    onFormSubmit () {
      this.$store.dispatch('questions/onAddUserSelectedAnswers', this.answerSelected)
      this.$emit('stepSuccess')
    }
  }
}
</script>

<style scoped>
.question-div {
  margin-left: 10px;
}
</style>
